import {CanActivateFn} from '@angular/router';
import {inject} from "@angular/core";
import {Observable} from "rxjs";
import {AuthService} from "../auth/auth.service";
import {StateService} from "./state.service";

// Holds every page until the organisation - and with it the permissions - is settled; without it a direct call
// (bookmark, F5, `?switchOrg=` from a mail) could build its forms read-only for good. Unauthenticated: authGuard decides.
export const stateReadyGuard: CanActivateFn = (): true | Observable<boolean> => {
  const authService: AuthService = inject(AuthService);
  return authService.isAuthenticated() ? inject(StateService).whenReady() : true;
};
